/*
 * @Author: Huangxianlong
 * @Date: 2023-08-10 16:51:23
 * @LastEditors: Huangxianlong
 * @LastEditTime: 2023-08-14 11:56:23
 * @FilePath: \monitor\src\language\data\index.js
 * @Description: 
 */
import Latest from "./latest";
import Home from "./home";
import Realtime from "./realtime";
const CN = {
  Home: Home.CN,
  Latest: Latest.CN,
  Realtime: Realtime.CN,
};
const EN = {
  Home: Home.EN,
  Latest: Latest.EN,
  Realtime: Realtime.EN,
};
export default {
  CN,
  EN
};



// WEBPACK FOOTER //
// ./src/language/data/index.js